package com.macrofocus.eflux.ui.perspective

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.TableType
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.ui.table.TableView
import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import org.mkui.component.CPComponent
import react.FC
import react.Props
import web.cssom.Color
import web.cssom.Position
import web.cssom.px

class TablePerspective(private val dl: DataLoader, tableType: MutableProperty<TableType>? = null, crossBorder: MutableProperty<Boolean>? = null) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()

        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            TableView {
                this.dataLoader = dl
                this.tableType = tableType
                this.crossBorder = crossBorder
                this.show = true
                this.transparent = Color("rgba(255, 255, 255, 0.7)")
            }
        }
    }

}